import React from 'react'
import { duration, fullDateAndTime } from '../../../../lib/date'
import { capitalize } from '../../../../services/utils'
import DisplayField from '../../../atoms/form/display-field/DisplayField'
import Form from '../../../atoms/form/Form'
import Text from '../../../atoms/text/Text'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import SimpleModal from '../../../organisms/standard-modal/SimpleModal'

interface PreviewModalProps {
  isOpen: boolean
  onClose: () => void
  schedule: API.EventSchedule
  'data-test'?: string
}

const formatRoundSchedule = (roundSchedule: API.RoundSchedule, roundType: API.EventSchedule['roundType']): string | React.ReactNode => {
  if (roundType === 'facilitated') {
    return `${roundSchedule.timeAllocated} mins`
  }
  return <InlineGroup spaceLeft={2}>
    <div className='input-width'>
      <Text size='sm' className='input-width'>{fullDateAndTime(roundSchedule.startTime!)}</Text>
    </div>
    <div className='input-width'>
      <Text size='sm' className='input-width'>{fullDateAndTime(roundSchedule.finishTime!)}</Text>
    </div>
    <div className='input-width'>
      <Text size='sm' className='input-width'>{duration(new Date(roundSchedule.startTime!), new Date(roundSchedule.finishTime!))}</Text>
    </div>
  </InlineGroup>
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  isOpen,
  onClose,
  schedule,
  ...props
}) => {
  const numberOfRounds = schedule.schedules.length - 1
  return <SimpleModal
    size='large'
    data-test={props['data-test']}
    showCloseButton
    isOpen={isOpen}
    onClose={onClose}
    isScrollable
  >
    <h2>Round Schedule</h2>
    <Form>
      <DisplayField label='Round Type' value={capitalize(schedule.roundType)} />
      <DisplayField label='Number Of Rounds' value={numberOfRounds} />
      {schedule.roundType === 'scheduled' && <DisplayField label='' value={
        <InlineGroup spaceLeft={2}>
          <div className='input-width'>
            <Text size='sm' className='input-width' bold>Starting Date and Time</Text>
          </div>
          <div className='input-width'>
            <Text size='sm' className='input-width' bold>Finishing Date and Time</Text>
          </div>
          <div className='input-width'>
            <Text size='sm' className='input-width' bold>Round Duration</Text>
          </div>
        </InlineGroup>
      }/>}
      {schedule.schedules.map((roundSchedule: API.RoundSchedule, i: number) => (
        <DisplayField key={i} label={i <= numberOfRounds - 1 ? `Round ${i+1}` : 'WrapUp Round'} value={formatRoundSchedule(roundSchedule, schedule.roundType)} />
      ))}
    </Form>
  </SimpleModal>
}

export default PreviewModal
